import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const categoria: AnaColumn[] = [

    {
      itemType: "group", colCount: "1", data: [
        { type: 'campo', dataField: "id", dataType: "", caption: "Codice", width: "40", hideOnEdit: true },
        { type: 'campo', dataField: "descrizione", dataType: "", caption: "Descrizione", width: 25.5 * aspect, maxLength: "255", maxSize: 255 },
        { type: 'campo', dataField: "note", dataType: "", width: 25.5 * aspect, editorType: "dxTextArea" },
        { type: 'campo', colVisible: false, dataField: "versione", hideOnEdit: true, dataType: "" },
        { type: 'campo', dataField: "nomeTabella", dataType: "", hideOnEdit: true, colVisible: false},
      ]
    },
  ]